/* 解决 ios12 中 input 弹出页面整体向上移动导致页面整体上移的 bug */
export function scrollTopRender() {
  if (/iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase()) && document.body) {
    setTimeout(() => {
      const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(scrollHeight - 1, 0));
    }, 100);
  }
}

/* 弹层body禁止滚动 */
let top = 0;
export function stopBodyScroll(isFixed) {
  let bodyEl = document.body;
  if (isFixed) {
    top = window.scrollY;
    bodyEl.style.position = 'fixed';
    bodyEl.style.top = -top + 'px';
  } else {
    bodyEl.style.position = '';
    bodyEl.style.top = '';
    window.scrollTo(0, top); // 回到原先的top
  }
}

/* 判断宿主在微信小程序 or 微信浏览器 */
export function isWechatMiniProgram() {
  const ua = navigator.userAgent.toLowerCase();
  return new Promise((resolve, reject) => {
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      // eslint-disable-next-line no-undef
      wx.miniProgram.getEnv(res => {
        resolve(Boolean(res.miniprogram));
      });
    } else {
      reject();
    }
  });
}

/* 获取url参数 */
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // 匹配目标参数
  var result = window.location.search.substr(1).match(reg); // 对querystring匹配目标参数
  if (result != null) {
    return decodeURIComponent(result[2]);
  } else {
    return null;
  }
}

/** 将url参数转为json
 * str可以不传 默认是当前的location.search
 */
export function url2json(str) {
  let search = str || location.search;
  if (search) {
    let pos = search.indexOf('?');
    if (pos !== -1) {
      search = search.substring(pos + 1);
      const res = {};
      search.split('&').forEach(element => {
        const arr = element.split('=');
        res[arr[0]] = arr[1] || undefined;
      });
      return res;
    }
  }
  return {};
}

/** 获取唯一随机id值 */
export const getUuid = () => {
  const s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  // eslint-disable-next-line no-bitwise
  s[19] = hexDigits.substr((+s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  // eslint-disable-next-line no-multi-assign
  s[8] = s[13] = s[18] = s[23] = '-';

  return s.join('');
};

export const LOCAL_STORAGE_TRACK = 'market-userchannel-fingerprint';

/** 生成标识浏览器唯一性的指纹信息，保存到 localStorage 中，作用类似小程序的open_id */
export const generateFingerprintSaveToLocalStorage = () => {
  if (window.localStorage.getItem(LOCAL_STORAGE_TRACK)) return;

  /** 用户的唯一标识，通过 clientJS 生成，如果未生成会用 uuid 进行降级 */
  const fingerprint = getUuid();

  window.localStorage.setItem(LOCAL_STORAGE_TRACK, fingerprint);
};

export const checkHkLoginPhone = mobile => {
  return /^[4-9]\d{7}$/.test(mobile);
};
